// extracted by mini-css-extract-plugin
export default {"-large":"grid-stock-video-item-module__-large--lhrGr","mobileVideoItem":"grid-stock-video-item-module__mobileVideoItem--Dwovr"};